import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

interface AuthModalState {
  isLoading: boolean;
}

const initialState: AuthModalState = {
  isLoading: false
};

export const AuthModalStore = signalStore(
  withState(initialState),
  withMethods((store) => ({
    updateIsLoading: (isLoading: boolean) => {
      patchState(store, { isLoading });
    }
  }))
);
